// path: src/pages/ISA/Simulador/index.js
import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Content } from 'rsuite';
import { LoadingSpiner } from '../../../components/LoadingSpinner';
import Warning from '../../../components/Warning';

import { getBilheteDoSimulador, renovarSessaoDoSimulador, SITUACAO_DO_BILHETE } from '../../../services/SimuladorService';

/**
 * Renovação da sessão a quatro minutos, uma margem abaixo dos cinco de validade do token de travessia; a fonte é a configuração do gateway, e se lá mudar, aqui muda junto.
 */
const INTERVALO_DE_RENOVACAO_EM_MILISSEGUNDOS = 240000;

/**
 * Ponto único da redação dos avisos: a recusa não distingue contrato de cadastro porque o gateway não manda isso, e a indisponibilidade não fala em permissão.
 */
const AVISOS = {
  [SITUACAO_DO_BILHETE.SEM_ACESSO]: {
    titulo: 'Negociação manual não liberada para este acesso',
    texto: 'Seu acesso à Negociação manual não está liberado. Fale com quem responde pelo contrato da sua empresa na InfoPrice para pedir a liberação.',
  },
  [SITUACAO_DO_BILHETE.INDISPONIVEL]: {
    titulo: 'Não foi possível abrir a Negociação manual',
    texto: 'Tente novamente em alguns minutos. Se continuar assim, avise o suporte da InfoPrice.',
  },
};

/**
 * Abre o simulador num quadro embutido com `src` posto à mão, porque o bilhete vale uma vez só e uma remontagem do React o gastaria de novo.
 * A renovação nunca troca o `src`: isso recarregaria o simulador e perderia o que o usuário digitou.
 */
const Simulador = () => {
  // Sem identificador na rota, a ausência segue como está para o pedido de bilhete, que então abre a lista de análises; valor de recuo levaria a uma análise inexistente.
  const { id } = useParams();
  // O quadro é aberto UMA vez no ciclo de vida do componente. Sem esta guarda,
  // uma remontagem refaria a travessia com um bilhete já gasto e a tela ficaria
  // em branco sem dizer por quê.
  const jaAbriu = useRef(false);
  // Começa em nulo: ainda não houve resposta, e por isso a tela não avisa nada.
  const [situacao, setSituacao] = useState(null);

  useEffect(() => {
    if (jaAbriu.current) {
      return;
    }

    jaAbriu.current = true;
    getBilheteDoSimulador(id).then(resultado => {
      setSituacao(resultado.situacao);

      if (resultado.situacao === SITUACAO_DO_BILHETE.ABERTO) {
        document.getElementById('simuladorContainer').setAttribute('src', resultado.url);
      }
    });
  }, [id]);

  // A renovação vive num efeito próprio e SÓ COMEÇA depois que o primeiro
  // bilhete foi entregue. É a saída antecipada abaixo que impede o portal de
  // pedir bilhete de quatro em quatro minutos para quem acabou de ser recusado.
  useEffect(() => {
    if (situacao !== SITUACAO_DO_BILHETE.ABERTO) {
      return undefined;
    }

    const renovacao = setInterval(() => {
      getBilheteDoSimulador(id).then(resultado => {
        if (resultado.situacao === SITUACAO_DO_BILHETE.ABERTO) {
          renovarSessaoDoSimulador(resultado.url);
          return;
        }

        // Recusa encerra a renovação sem tirar o quadro da tela; indisponibilidade é transitória e fica para a próxima tentativa.
        if (resultado.situacao === SITUACAO_DO_BILHETE.SEM_ACESSO) {
          clearInterval(renovacao);
        }
      });
    }, INTERVALO_DE_RENOVACAO_EM_MILISSEGUNDOS);

    return () => clearInterval(renovacao);
  }, [id, situacao]);

  const aviso = AVISOS[situacao];

  return (
    <Container className="main-container simulador-page">
      <LoadingSpiner size="md" />
      <Content className="content">
        {aviso ? (
          // O papel de alerta não é enfeite: é o ponto de apoio estável do
          // teste, que assim não depende da marcação interna do rsuite.
          <div className="simulador-page__aviso" role="alert">
            <Warning title={aviso.titulo} description={aviso.texto} />
          </div>
        ) : (
          <iframe title="simulador" id="simuladorContainer" className="content__iframe" />
        )}
      </Content>
    </Container>
  );
};
export default Simulador;
